export enum StorageEnums {
	AUTH_TOKEN = 'app_auth_token',
	PAYMENT_DATA = 'app_payment-data',
	DEEP_LINK = 'app_deep-link',
	USER_LOGGED_IN = 'app_user_logged_in',
	USER_FIELDS_VERIFIED = 'app_user_fields_verified',
	REFRESH_TOKEN = 'app_refresh_token',
	LANG = 'app_lang',
	BookingStep = 'app_booking-step',
	Bookings = 'app_bookings',
	BookingAtTheGate = 'app_bookings-at-the-gate',
	RETURN_URL = 'app_return-url',
	WISH_TOWER_INFORMATION = 'app_with_tower_information',
	ONESIGNAL_DTO = 'app_one-signal-dto',
	MIN_SERVER_API_VERSION = 'app_min_server_api_version',
	APP_VERSION = 'app_app-version',
	USER = 'app_user',
	USER_ID = 'app_user-id',
	USER_EMAIL = 'app_user-email',
	DoorStatusOpened = 'app_door-status-opened',
	IsSignInInSocial = 'app_is-sign-in-in-social',
	WasPAndTShownFromHomePage = 'app_was-p&t-shown',
	EmailsForFilter = 'app_emails-for-filter',
	PurchaseRedirectUrl = 'app_purchase-redirect-url',
	PRODUCT_LIST = 'app_product_list',
	IS_SAME_USER = 'app_is_same_user',
	IsStage = 'app_is-stage',
	ApiUrl = 'app_api-url',
	USER_LOCATION = 'app_user-location',
	SHOW_MARKETPLACE = 'app_show-marketplace',
	SUB_START_DATE = 'app_sub-start-date',
	LIKED_WISH = 'app_liked-wish'
}

export enum RouteEnums {
	AuthSignIn = 'sign-in',
	AuthSignUp = 'sign-up',
	AuthEmailVerification = 'email-verification',
	AuthForgotPassword = 'forgot-password',
	DashBoard = 'dashboard',
}

export enum ModalEnums {
	None = 'none',
	User = 'user',
	Box = 'box',
	Booking = 'booking',
	BookingAndBox = 'booking-and-box',
}

export enum ModalSizeClassEnum {
	small = 'modal-small-class',
	medium = 'modal-medium-class',
	big = 'modal-big-class',
}

export enum DateFormat {
	DefaultFormat = 'yyyy-MM-DDTHH:mm:ss.SSSZ',
	ForDisplay = 'DD.MM.YYYY HH:mm',
	OnlyDate = 'DD.MM.YYYY',
	ForDatePicker = 'yyyy-MM-dd',
	ForDatePickerTime = 'HH:mm'
}


export enum TowerStatusEnum {

	/**
	 * V-Locker is open with V-Locker box at gate.
	 */
	OPEN,
	/**
	 * V-Locker is closed.
	 */
	CLOSED,
	/**
	 * V-Locker is rotating.
	 */
	ROTATING,
	/**
	 * V-Locker is locked by a OPEN request.
	 */
	LOCKED,
	/**
	 * V-Locker is offline (no heartbeat received for a while).
	 */
	OFFLINE
}

export enum BookingStatus {
	Create,
	Start,
	OpenDoors,
	DoorsIsOpening,
	DoorIsOpen,
	DoorIsClosing,
	CloseDoors,
	Terminate,
	Subscription
}

export enum NetworkState {
	Connected = 'connected',
	Disconnected = 'disconnected'
}

export enum PermissionSettingNameEnum {
	locationIOS = 'locations',
	locationAndroid = 'location'
}

export enum SettingEnum {
	location = 'location'
}

export enum AlertType {
	RevokeAccess,
	StopAccess,
	OpenDoor,
	ShareWithEmailAlreadyShared,
	BookingOwner,
	Default,
	OpenDoorShareInactive,
	TerminateWithShares,
	SkipCardAdding,
	AccountACannotBeUsed,
	EmailNotFound,
	DataIsIncomplete,
	ForgetToCloseTheDoors
}

export enum AuthTypes {
	Facebook = 'facebook',
	Google = 'google',
	Apple = 'apple',
	Swisspass = 'swisspass',
	Email = 'email'
}

export enum Currency {
	USD = '$',
	EUR = '€',
	CHF = '₣'
}

export enum Statuses {
	DRAFT = 'order-status.draft',
	SUBMIT = 'order-status.submitted',
	PAID = 'order-status.paid',
	CANCEL = 'order-status.canceled',
	ACCEPT = 'order-status.packaging',
	DELIV = 'order-status.delivery',
	COMPL = 'order-status.completed',
	FINAL = 'order-status.finalized'
}
